import { forwardRef } from 'react'
import { Link, type LinkProps, useMatch } from '@remix-run/react'
import { route, type RouteParams } from 'routes-gen'

export const LinkToPostfach = forwardRef<HTMLAnchorElement, Omit<LinkProps, 'to'>>((props, ref) => {
  const match = useMatch('/kundenzugang/depot/:id' satisfies keyof RouteParams)
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <Link
      {...props}
      ref={ref}
      to={
        match && match.params.id
          ? route('/kundenzugang/postfach/:depotId', { depotId: match.params.id })
          : route('/kundenzugang/postfach')
      }
    />
  )
})
LinkToPostfach.displayName = 'LinkToPostfach'

export const useUrlToPostfach = () => {
  const match = useMatch('/kundenzugang/depot/:id' satisfies keyof RouteParams)
  return match && match.params.id
    ? route('/kundenzugang/postfach/:depotId', { depotId: match.params.id })
    : route('/kundenzugang/postfach')
}
